import type {MultiValue, SingleValue} from "react-select";

import type {IOption} from "../types/IOption";

export const isMultiOnChangeValue = <Value, Option extends IOption<Value>, IsMulti extends boolean>(
    newValue: MultiValue<Option> | SingleValue<Option>,
    isMulti?: IsMulti
): newValue is MultiValue<Option> => {
    return Boolean(isMulti);
};
